/**
 * Positional `calcParams` parsing, shared by the indicator draw functions.
 *
 * klinecharts stores calc params as an untyped positional array, so every draw
 * starts by coercing `cp[i]` with a fallback. These helpers keep that parsing
 * uniform instead of hand-rolled per indicator.
 */

/** Number at `idx`, or `fallback` when absent or not finite. */
export function numParam(cp: readonly unknown[], idx: number, fallback: number): number {
  const value = Number(cp[idx] ?? fallback)
  return Number.isFinite(value) ? value : fallback
}

/** Boolean at `idx`, or `fallback` when absent. */
export function boolParam(cp: readonly unknown[], idx: number, fallback: boolean): boolean {
  const value = cp[idx]
  return value === undefined ? fallback : Boolean(value)
}

/** String at `idx`, or `fallback` when absent. */
export function strParam(cp: readonly unknown[], idx: number, fallback: string): string {
  return String(cp[idx] ?? fallback)
}
